import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import { BDSMForm } from '../../../../../components/form/BDSMForm';
import { changePassword } from '../../../../../api/ApiEndpoints';
import { useAlert } from 'react-alert';

const validation = Yup.object().shape({
    oldPassword: Yup.string().required(),
    newPassword: Yup.string().required(),
    repeatedNewPassword: Yup.string().required(),
});

export const PasswordBlock = () => {

    const { t } = useTranslation('settings');
    const alert = useAlert();

    const handleSubmit = (record) => {
        changePassword(record)
            .then(() => alert.success(t('alert:saveSuccess')))
            .catch(() => alert.error(t('alert:saveError')));
    };

    const cancel = () => {
        //     ignore
    };

    const getFormModel = () => {
        return {
            initValues: {
                oldPassword: '',
                newPassword: '',
                repeatedNewPassword: '',
            },
            onSubmit: (form) => handleSubmit(form),
            onCancel: (c) => cancel(c),
            validationSchema: validation,
            fieldNames: ['oldPassword', 'newPassword', 'repeatedNewPassword'],
            className: 'mb-3',
            label: [
                t('changePassword.oldPassword'),
                t('changePassword.newPassword'),
                t('changePassword.repeatedNewPassword'),
            ],
            types: ['password', 'password', 'password'],
            selectData: [null, null, null],
            inputFieldsClass: '',
            hideCancel: true
        };
    };

    return <BDSMForm form={getFormModel()} />;
};